import { useSelector } from 'react-redux';

import Store from 'redux/store';
import {
  GET_INITIAL_TOKENS_FAIL,
  GET_INITIAL_TOKENS_SUCCESS,
} from 'redux/Reducers/Template/TemplateReducer';

const useTemplate = () => {
  const userProfile = useSelector((state) => state?.oidc?.user?.profile);

  const getTemplate = () => {
    const campaignId =
      (userProfile && userProfile['custom:campaign_id']) || process.env.REACT_APP_TENANT_ID;
    const catalogId =
      (userProfile && userProfile['custom:catalog_id']) || process.env.REACT_APP_CATALOG_ID;

    const urlPath =
      process.env.REACT_APP_TEMPLATE_DOMAIN || 'https://vertice-ds.s3.amazonaws.com/templates/';
    const fileName = `skin-${campaignId}-${catalogId}.json`;

    return `${urlPath}${fileName}`;
  };

  const fetchTemplate = async () => {
    try {
      const response = await fetch(getTemplate());

      if (!response.ok) {
        console.error(`Network response was not ok: ${response.status}`);
      }

      const data = await response.json();
      Store.dispatch({
        type: GET_INITIAL_TOKENS_SUCCESS,
        payload: {
          ...data,
        },
      });

      return data;
    } catch (error) {
      Store.dispatch({
        type: GET_INITIAL_TOKENS_FAIL,
        error,
      });

      console.error(error);
    }
  };

  return { fetchTemplate };
};

export default useTemplate;
